import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import env from '../../config/env.var'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    map: null,
    tileLayerRetval: null,
    shape_type: 'shape1',
    shape: { // 生のgeojson
      shape1: null,
      shape2: null,
      shape3: null,
    },
    layers: { // 色付け済みのマップオブジェクトになったshape
      shape1: null,
      shape2: null,
      shape3: null,
    },
    csv: {  
      shape1: null,
      shape2: null,
      shape3: null,
    },
    shizen_saigai: Array,
    tameike: Array,
    // map_version: ['mesh', 'tile'],

  },
  mutations: {
    setMap (state, map) {
      state.map = map
    },
    setShape (state, res) {
      state.shape[state.shape_type] = res
    },
    setShapeType (state, shape_type) {
      state.shape_type = shape_type
    },
    setCsv (state, dic) {
      state.csv[state.shape_type] = dic
    },
    // layer を map に追加する．  
    setShizenSaigai (state, res) {
      state.shizen_saigai = res.data
    }, 
    setTameike (state, res) {
      state.tameike = res.data
    },   
    // layer または marker を map に追加する．
    addLayer (state, L) {
      L.addTo(state.map)
      state.layers[state.shape_type] = L
    },
    addMarker (state, L) {
      L.addTo(state.map)
    },
    removeMarker (state, L) {
      state.map.removeLayer(L)
    },
    removeLayer (state, layer) {
      state.map.removeLayer(layer)
      layer.clearLayers()
    },
  },
  actions: {
    async getShape (context) {
      await axios.get(`${env.localAPI}/shape/${this.state.shape_type}`, {
      })
      .then(res => {
        context.commit('setShape', res.data)
      })
      .catch((error) => {
        console.log(error) // eslint-disable-line
        // console.log("shapeを取得できませんでした");
      })
    },
    // shapeに紐付けるデータを取得
    async getCsv (context) {
      await axios.get(`${env.localAPI}/csv/${this.state.shape_type}`)
      .then(res => {
        let dic = {}
        res.data.forEach(ele => {
          // あとで扱いやすいように連想配列に変換
          dic[ele["code"]] = { 
            value: Number(ele["value"]),
            meter: ele["meter"],
            danger: ele["danger"]
          }
        });
        context.commit('setCsv', dic)
      })
      .catch(() => {
        // console.log("shapeを取得できませんでした");
      })
    },

    async getShizenSaigai (context) {
      await axios.get(`${env.localAPI}/csv/shizen_saigai`)
      .then(res => {
        context.commit('setShizenSaigai', res)
      })
      .catch(() => {
        // console.log("shapeを取得できませんでした");
      })
    },
    async getTameike (context) {
      await axios.get(`${env.localAPI}/csv/tameike`)
      .then(res => {
        context.commit('setTameike', res)
      })
      .catch(() => {
        // console.log("shapeを取得できませんでした");
      })
    },
  },
  modules: {
  }
})
